import RenterInformation from './RenterInformation';

export default RenterInformation;
